/* eslint-disable max-len */
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ViewImageComponent from '../../../components/ViewImageComponent';
import UploadFile from '../../../components/ViewImageComponent/UploadFile';
import DocPlusIcon from '../../../svgs/DocPlusIcon';
import './DocumentPage.scss';

interface IDocumentPage{
  payload:any;
  fetchUser?:any;
}
const DocumentPage = ({ payload, fetchUser }:IDocumentPage) => {
  const { documents } = payload;
  const { customerId } = useParams<{ customerId: string }>();
  const [uploadModal, setUploadModal] = useState(false);
  return (
    <div className="document-cover-page">
      <div className="row">
        {
          documents?.map((list) => (
            <div className="col-xl-4 col-md-6 col-sm-12 ">
              {/* {list?.documentType} */}
              <div style={{ marginBottom: '32px' }}>
                <ViewImageComponent
                  pageName="document"
                  name={list?.documentType}
                  docType={list?.docKey}
                  payload={list}
                  merchantId={customerId}
                  imageSize={list?.meta?.file_size}
                  imageType={list?.meta?.contentType}
                  fileExt={list?.file_ext}
                  fetchUser={fetchUser}
                  uploadDocumentType="admin_user_upload"
                  hideActions={payload.isDeleted}
                  canUpdatePermission="can-upload-admin-user-document"
                  canAcceptPermission="can-approve-document"
                  canRejectPermission="can-reject-document"
                  showStatusIcon
                />
              </div>
            </div>
          ))
        }
      </div>
      {
        uploadModal && <UploadFile closeModal={() => setUploadModal(false)} uploadDocumentType="admin_user_upload" fetchUser={fetchUser} merchantId={customerId} uploadPermissionName="can-upload-admin-user-document" />
      }
      {!payload?.isDeleted && (
      <div className="customer-upload-document-button" onClick={() => setUploadModal(true)}>
        <div className="customer-upload-document-inner-cover">
          <DocPlusIcon />
          <div>Upload Additional Document</div>
        </div>

      </div>
      )}
    </div>
  );
};
export default DocumentPage;
